import React, {FunctionComponent} from 'react';
import styles from './landing.page.module.scss';
import {useTranslation} from 'react-i18next';
import stadimLogo from '../../../assets/images/stadim_logo.png';
import LanguageSelectorComponent, {LanguageSelectorLocation} from '../../components/language-selector/language-selector.component';

const LandingPage: FunctionComponent = () => {
    const {t} = useTranslation();
    return (
        <div className={styles.content}>
            <div className={styles.leftPanel}>
                <div className={styles.wrapper}>
                    <div className={styles.topContainer}>
                        <img src={stadimLogo} className={styles.logo} alt="placeholder"/>
                        <LanguageSelectorComponent languageSelectorLocation={LanguageSelectorLocation.Body}/>
                    </div>
                    <div className={styles.textPanel}>
                        <p className={styles.titleText}>{t('intro_p_1')}</p>
                        <div className={styles.bodyText}>
                            <p className={styles.bold}>{t('intro_landing')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.rightPanel}>
                <div className={styles.opacityMask}/>
            </div>
        </div>
    )
}

export default LandingPage;
